import React from 'react';
import { Route } from 'react-router-dom';

const AppRoute = ({
  component: Component,
  layout: Layout,
  canonicalUrl,
  ...rest
}) => {

  Layout = (Layout === undefined) ? props => (<React.Fragment>{props.children}</React.Fragment>) : Layout;

  return (
    <Route
      {...rest}
      render={props => (
        <Layout canonicalUrl={canonicalUrl}>
          <Component {...props} {...rest} />
        </Layout>
      )} />
  );
}

export default AppRoute;